import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addSpace'
})
export class AddSpacePipe implements PipeTransform {
    transform(value: string | null | undefined, place: 'start' | 'end' = 'end'): string {
        if (!value) {
            return '';
        }
        const trimmedValue = value.trim();
        if (!trimmedValue) {
            return '';
        }
        return place === 'start' ? ` ${trimmedValue}` : `${trimmedValue} `;
    }
}
